import { useT } from '../../i18n';
import { useWorkspaceNavigate } from '../../workspace-path';
import { HistoryList } from '../history/history-list';
import { useHistory, useHistoryMembers } from '../history/use-history';
import { SettingsPage } from './settings-page';

/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ ux-pass-2 · Auditnapló — everything that happened in the workspace.        │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * The owner: *"a global audit log, that logs everything that happens in the system … when was the
 * data changed, who changed the data, what data was changed, how was it changed, and a detailed
 * view where you can see what the value was before, and what it became."* `GET /audit`, through the
 * same `HistoryList` every record's own History tab uses, with the two things only this page has:
 * the *Mi* column and a filter by record type.
 *
 * ⚠️⚠️ **`audit.view`, ADMINS ONLY, AND UNTRIMMED — U-8.** The rows carry money and other people's
 * leave, so there is no narrower grant; the rail hides the section from everybody else and the
 * server refuses them, which `HistoryList` shows as the denied state rather than an error.
 *
 * ⚠️ **NOT LIVE, AND THAT IS U-8 TOO.** The log changes on every write anybody makes, so a
 * subscription would refetch it continuously while somebody is reading page three. *Frissítés*
 * re-reads on request instead, keeping the page, the search and the filters.
 */
export function AuditSection() {
  const t = useT();
  const go = useWorkspaceNavigate();
  const history = useHistory('/audit');
  const members = useHistoryMembers();

  return (
    <div data-screen="settings-audit" className="flex min-h-0 flex-1 flex-col">
      <SettingsPage
        title={t('settings.nav.audit')}
        secondaryAction={{
          label: t('history.refresh'),
          icon: 'refresh-cw',
          onSelect: () => {
            void history.reload();
          },
        }}
      >
        <HistoryList
          entries={history.entries}
          loading={history.loading}
          failure={history.failure}
          onRetry={() => void history.reload()}
          query={history.query}
          members={members}
          showEntity
          entityFilter
          columnsKey="audit-log"
          onOpenPath={(path) => {
            go(path);
          }}
        />
      </SettingsPage>
    </div>
  );
}
